require('../_design_files/scss/promo-badge.scss');

angular.module('eatself').component('promoBadge',{
	template: require('../templates/promo-badge.html'),
})